function SubscriptionCollectionsLoadingView() {
  return (
    <>
      LOADING
    </>
  );
}

export default SubscriptionCollectionsLoadingView;
